import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Formik, ErrorMessage } from 'formik'
import { Form, Field, Select } from 'formik-antd'
import _ from 'lodash'
import { SketchPicker } from 'react-color'
import { MultiSelect } from 'primereact/multiselect'
import validate from './validation/colorForm'
import { saveAs } from 'file-saver'
// import 'antd/dist/antd.css'
import reactCSS from 'reactcss'
import SelectCompAntd from '../common/SelectCompAntd'

const { Option } = Select

const branchDefault = 'all'
const departmentDefault = 'all'
const periodDefault = 'weekly'
const reportDefault = 'pdf'

export default class ColorForm extends Component {
    state = {
        background: '#fff',
        displayColorNormalPicker: false,
        displayColorLeavePicker: false,
        colorNormal: '#9B9B9B',
        colorLeave: '#9B9B9B',
    }
    handleSubmit = (data, setSubmitting) => {
        const { id } = data

        if (id) {
            this.props.actions
                .updateColors(data)
                .then(res => this.props.handleClose())
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        } else {
            this.props.actions
                .addColors(data)
                .then(res => this.props.handleClose())
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        }
    }

    handleColorNormalChange = (data, form) => {
        form.setFieldValue('colorNormal', data.hex)

        const styles = reactCSS({
            default: {
                colorNormal: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: data.hex,
                },
            },
        })

        form.setFieldValue('stylesColorNormal', styles)

        this.setState({ colorNormal: data.hex })
    }

    handleColorLeaveChange = (data, form) => {
        form.setFieldValue('colorLeave', data.hex)

        const styles = reactCSS({
            default: {
                colorLeave: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: data.hex,
                },
            },
        })

        form.setFieldValue('stylesColorLeave', styles)

        this.setState({ colorLeave: data.hex })
    }


    handleNormalClick = () => {
        this.setState({
            displayColorNormalPicker: !this.state.displayColorNormalPicker,
        })
    }

    handleLeaveClick = () => {
        this.setState({
            displayColorLeavePicker: !this.state.displayColorLeavePicker,
        })
    }

    handleNormalClose = () => {
        this.setState({ displayColorNormalPicker: false })
    }

    handleLeaveClose = () => {
        this.setState({ displayColorLeavePicker: false })
    }

    handleVisibleChange = visible => {
        this.setState({ visible })
    }

    disabledStartDate = startValue => {
        const { endValue } = this.state
        if (!startValue || !endValue) {
            return false
        }
        return startValue.valueOf() > endValue.valueOf()
    }

    disabledEndDate = endValue => {
        const { startValue } = this.state
        if (!endValue || !startValue) {
            return false
        }
        return endValue.valueOf() <= startValue.valueOf()
    }

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        })
    }

    onStartChange = (values, form) => {
        // console.log();
        this.onChange('startValue', values)
    }

    onEndChange = value => {
        this.onChange('endValue', value)
    }

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true })
        }
    }

    handleEndOpenChange = open => {
        this.setState({ endOpen: open })
    }


    employeeOptions = empList => {
        return empList
    }

    onChange = (date, dateString) => {
        console.log(date, dateString)
    }

    handleBranchesChange = (e, form) => {
        form.setFieldValue('branches', e.value)
    }

    handleDepartmentsChange = (e, form) => {
        form.setFieldValue('departments', e.value)
    }

    initialize = values => {
        if (_.isEmpty(values)) {
            return values
        }
        const initial = {
            id: values.id,
            branches: [
                {
                    name: values.PayrollBranchName,
                    code: `${values.PayrollBranch}`,
                },
            ],
            departments: [
                {
                    name: values.PayrollDepartmentName,
                    code: `${values.PayrollDepartment}`,
                },
            ],
            colorNormal: values.PayrollColorNormalCode,
            colorLeave: values.PayrollColorLeaveCode,
        }

        return initial
    }

    render() {
        const empty = {
            branches: [],
            departments: [],
            colorNormal: this.state.colorNormal,
            colorLeave: this.state.colorLeave,
        }

        const initialOptions = this.initialize(this.props.data)
        const initialValues = _.isEmpty(initialOptions) ? empty : initialOptions

        const optionsDisabled = this.props.data.id? true: false

        const styles = reactCSS({
            default: {
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        })

        const stylesColorNormal = reactCSS({
            default: {
                colorNormal: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: initialValues.colorNormal,
                },
            },
        })

        const stylesColorLeave = reactCSS({
            default: {
                colorLeave: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: initialValues.colorLeave,
                },
            },
        })

        // initialValues.styles = styles
        initialValues.stylesColorNormal = stylesColorNormal
        initialValues.stylesColorLeave = stylesColorLeave

        let branchOptions = this.props.branches.slice(1).map(b => {
            let o = {}

            o.name = b.label
            o.code = b.value
            return o
        })
        let departmentOptions = this.props.departments.slice(1).map(b => {
            let o = {}
            o.name = b.label
            o.code = b.value
            return o
        })

        return (
            <Formik
                initialValues={initialValues}
                validate={validate()}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                        this.handleSubmit(values, setSubmitting)
                    }, 400)
                }}
            >
                {colorForm => (
                    <Form onSubmit={colorForm.handleSubmit}>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row form-group">
                                    <div className=" col-sm-4 col-md-4 padright15">
                                        <label
                                            htmlFor="branches"
                                            className="control-label"
                                        >
                                            Branches
                                        </label>
                                    </div>
                                    {/* <SelectCompAntd
                                            id="branches"
                                            name="branches"
                                            defaultValue={
                                                colorForm.values.branch
                                            }
                                            readOnly
                                            placeholder="Select Branch"
                                            className="form-control"
                                            data={this.props.branches}
                                            handleChange={this.handleBranchChange.bind(
                                                this
                                            )}
                                        ></SelectCompAntd> */}
                                    <div className="col-sm-8 col-md-8">
                                        <MultiSelect
                                            optionLabel="name"
                                            value={colorForm.values.branches}
                                            options={branchOptions}
                                            onChange={e =>
                                                this.handleBranchesChange(
                                                    e,
                                                    colorForm
                                                )
                                            }
                                            disabled={optionsDisabled}
                                        />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className=" col-sm-4 col-md-4 padright15">
                                        <label
                                            htmlFor="departments"
                                            className="control-label"
                                        >
                                            Departments
                                        </label>
                                    </div>
                                    {/* <SelectCompAntd
                                            id="departments"
                                            name="departments"
                                            defaultValue={
                                                colorForm.values.department
                                            }
                                            readOnly
                                            placeholder="Select Department"
                                            className="form-control"
                                            data={this.props.departments}
                                            handleChange={this.handleDepartmentChange.bind(
                                                this
                                            )}
                                        ></SelectCompAntd> */}
                                    <div className="col-sm-8 col-md-8">
                                        <MultiSelect
                                            optionLabel="name"
                                            value={colorForm.values.departments}
                                            options={departmentOptions}
                                            onChange={e =>
                                                this.handleDepartmentsChange(
                                                    e,
                                                    colorForm
                                                )
                                            }
                                            disabled={optionsDisabled}
                                        />
                                    </div>
                                </div>

                                <div className="row form-group">
                                    <div className="col-sm-6 col-md-6 padright15">
                                        <div className="form-group">
                                            <label
                                                htmlFor="colorNormal"
                                                className="control-label"
                                            >
                                                Work
                                            </label>
                                            <div>
                                                <div
                                                    style={
                                                        styles
                                                            .swatch
                                                    }
                                                    onClick={
                                                        this.handleNormalClick
                                                    }
                                                >
                                                    <div
                                                        style={
                                                            colorForm.values
                                                                .stylesColorNormal
                                                                .colorNormal
                                                        }
                                                    />
                                                </div>
                                                {this.state
                                                    .displayColorNormalPicker ? (
                                                    <div
                                                        style={
                                                            styles.popover
                                                        }
                                                    >
                                                        <div
                                                            style={
                                                                styles
                                                                    .cover
                                                            }
                                                            onClick={
                                                                this
                                                                    .handleNormalClose
                                                            }
                                                        />
                                                        <SketchPicker
                                                            id="colorNormal"
                                                            name="colorNormal"
                                                            defaultValue={
                                                                colorForm.values
                                                                    .colorNormal
                                                            }
                                                            color={
                                                                this.state
                                                                    .colorNormal
                                                            }
                                                            value={
                                                                colorForm.values
                                                                    .colorNormal
                                                            }
                                                            onChange={data =>
                                                                this.handleColorNormalChange(
                                                                    data,
                                                                    colorForm
                                                                )
                                                            }
                                                            onChangeComplete={data =>
                                                                this.handleColorNormalChange(
                                                                    data,
                                                                    colorForm
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-sm-6 col-md-6 padright15">
                                        <div className="form-group">
                                            <label
                                                htmlFor="colorLeave"
                                                className="control-label"
                                            >
                                                Leave
                                            </label>
                                            <div>
                                                <div
                                                    style={
                                                        styles
                                                            .swatch
                                                    }
                                                    onClick={
                                                        this.handleLeaveClick
                                                    }
                                                >
                                                    <div
                                                        style={
                                                            colorForm.values
                                                                .stylesColorLeave
                                                                .colorLeave
                                                        }
                                                    />
                                                </div>
                                                {this.state
                                                    .displayColorLeavePicker ? (
                                                    <div
                                                        style={
                                                            styles.popover
                                                        }
                                                    >
                                                        <div
                                                            style={
                                                                styles
                                                                    .cover
                                                            }
                                                            onClick={
                                                                this
                                                                    .handleLeaveClose
                                                            }
                                                        />
                                                        <SketchPicker
                                                            id="colorLeave"
                                                            name="colorLeave"
                                                            defaultValue={
                                                                colorForm.values
                                                                    .colorLeave
                                                            }
                                                            color={
                                                                this.state
                                                                    .colorLeave
                                                            }
                                                            value={
                                                                colorForm.values
                                                                    .colorLeave
                                                            }
                                                            onChange={data =>
                                                                this.handleColorLeaveChange(
                                                                    data,
                                                                    colorForm
                                                                )
                                                            }
                                                            onChangeComplete={data =>
                                                                this.handleColorLeaveChange(
                                                                    data,
                                                                    colorForm
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="submit"
                                className="btn btn-success pull-left btn-md-w"
                                disabled={colorForm.isSubmitting}
                            >
                                Ok
                            </button>
                            <button
                                type="button"
                                className="btn btn-default"
                                data-dismiss="modal"
                                onClick={this.props.handleClose}
                            >
                                Cancel
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }
}
